<template>
  <v-container fluid>
    <!-- KPIs Dashboard -->
    <v-row class="mb-4">
      <!-- KPIs de Ventas -->
      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #4CAF50' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Ventas Totales</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(totalSales || 0) }}
            </div>
            <div class="text-caption grey--text">
              Descuentos: {{ formatCurrency(totalDiscounts || 0) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- KPIs de Inventario -->
      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #2196F3' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Total Inventario</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatNumber(getTotalInventory()) }}
            </div>
            <div class="text-caption grey--text">{{ inventory.length }} categorías</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- KPIs de Movimientos -->
      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FF9800' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Ingresos de Caja</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(getTotalCashIn()) }}
            </div>
            <div class="text-caption grey--text">{{ cin.length }} movimientos</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- KPIs de Egresos -->
      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FF5252' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Egresos de Caja</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(getTotalCashOut()) }}
            </div>
            <div class="text-caption grey--text">{{ cout.length }} movimientos</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Barra de filtros -->
    <v-card class="mb-6" elevation="2">
      <v-app-bar flat dense color="secondary" dark>
        <v-toolbar-title>Resumen del Día</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="issueDate"
          label="Fecha"
          hide-details="auto"
          required
          dense
          outlined
          type="date"
          class="mx-2"
          style="max-width: 180px"
          @input="get_report"
        />
      </v-app-bar>
    </v-card>
    <v-row>
      <v-col md="6">
        <v-card height="100%">
          <v-card-title>Ventas</v-card-title>
          <v-data-table
            :headers="header_sales"
            :items="sales"
            :items-per-page="5"
            item-key="category"
            mobile-breakpoint="0"
            calculate-widths
            sort-by="category"
            class="elevation-0"
            loading-text="Cargando ..."
            dense
          >
            <template v-slot:[`item.quantity`]="{ item }">
              {{ parseFloat(item.quantity).toLocaleString(2) }}
            </template>
            <template v-slot:[`item.price`]="{ item }">
              {{ "$ " + parseFloat(item.price).toLocaleString(2) }}
            </template>
            <template v-slot:[`item.discount`]="{ item }">
              {{ "$ " + parseFloat(item.discount).toLocaleString(2) }}
            </template>
            <template slot="body.append">
              <tr>
                <th class="title">Total</th>
                <th class="text-right">{{ sumTable("sales", "quantity") }}</th>
                <th class="text-right">{{ sumTable("sales", "discount") }}</th>
                <th class="text-right">{{ sumTable("sales", "price") }}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card height="100%" color="deep-orange lighten-4">
          <v-card-title>Inventario</v-card-title>
          <v-data-table
            :headers="header_inventory"
            :items="inventory"
            :items-per-page="5"
            item-key="category"
            mobile-breakpoint="0"
            calculate-widths
            sort-by="category"
            class="elevation-0"
            loading-text="Cargando ..."
            dense
          >
            <template v-slot:[`item.quantity`]="{ item }">
              {{ parseFloat(item.quantity).toLocaleString(2) }}
            </template>
            <template v-slot:[`item.price`]="{ item }">
              {{ "$ " + parseFloat(item.price).toLocaleString(2) }}
            </template>
            <template v-slot:[`item.discount`]="{ item }">
              {{ "$ " + parseFloat(item.discount).toLocaleString(2) }}
            </template>
            <template slot="body.append">
              <tr>
                <th class="title">Total</th>
                <th class="text-right">{{ sumTable("inventory", "quantity") }}</th>
                <th class="text-right">{{ sumTable("inventory", "price") }}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card height="100%" color="cyan lighten-5">
          <v-card-title>Formas de pago</v-card-title>
          <v-data-table
            :headers="header_payments"
            :items="payments"
            :items-per-page="5"
            item-key="label"
            mobile-breakpoint="0"
            sort-by="category"
            class="elevation-0"
            loading-text="Cargando ..."
            dense
          >
            <template v-slot:[`item.quantity`]="{ item }">
              {{ parseFloat(item.quantity).toLocaleString(2) }}
            </template>
            <template v-slot:[`item.value`]="{ item }">
              {{ "$ " + parseFloat(item.value).toLocaleString(2) }}
            </template>
            <template slot="body.append">
              <tr>
                <th class="title">Total</th>
                <th class="text-right">{{ sumTable("payments", "quantity") }}</th>
                <th class="text-right">{{ "$ " + sumTable("payments", "value") }}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card height="100%" color="lime lighten-5">
          <v-card-title>Eventos</v-card-title>
          <v-data-table
            :headers="header_events"
            :items="events"
            :items-per-page="5"
            item-key="label"
            mobile-breakpoint="0"
            sort-by="category"
            class="elevation-0"
            loading-text="Cargando ..."
            dense
          >
            <template v-slot:[`item.quantity`]="{ item }">
              {{ parseFloat(item.quantity).toLocaleString(2) }}
            </template>
            <template v-slot:[`item.price`]="{ item }">
              {{ "$ " + parseFloat(item.price).toLocaleString(2) }}
            </template>
            <template slot="body.append">
              <tr>
                <th class="title">Total</th>
                <th class="text-right">{{ sumTable("events", "quantity") }}</th>
                <th class="text-right">{{ "$ " + sumTable("events", "price") }}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card height="100%" color="green lighten-5">
          <v-card-title>Ingreso</v-card-title>
          <v-data-table
            :headers="header_events"
            :items="cin"
            :items-per-page="5"
            item-key="label"
            mobile-breakpoint="0"
            sort-by="category"
            class="elevation-0"
            loading-text="Cargando ..."
            dense
          >
            <template v-slot:[`item.quantity`]="{ item }">
              {{ parseFloat(item.quantity).toLocaleString("es") }}
            </template>
            <template v-slot:[`item.price`]="{ item }">
              {{ "$ " + parseFloat(item.doc_val).toLocaleString("es") }}
            </template>
            <template slot="body.append">
              <tr>
                <th class="title">Total</th>
                <th class="text-right">{{ sumTable("cin", "quantity") }}</th>
                <th class="text-right">{{ "$ " + sumTable("cin", "doc_val") }}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card height="100%" color="red lighten-5">
          <v-card-title>Egresos</v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="header_events"
              :items="cout"
              :items-per-page="5"
              item-key="label"
              mobile-breakpoint="0"
              sort-by="category"
              class="elevation-0"
              loading-text="Cargando ..."
              dense
            >
              <template v-slot:[`item.quantity`]="{ item }">
                {{ parseFloat(item.quantity).toLocaleString("es") }}
              </template>
              <template v-slot:[`item.price`]="{ item }">
                {{ "$ " + parseFloat(item.doc_val).toLocaleString("es") }}
              </template>
              <template slot="body.append">
                <tr>
                  <th class="title">Total</th>
                  <th class="text-right">{{ sumTable("cout", "quantity") }}</th>
                  <th class="text-right">{{ "$ " + sumTable("cout", "doc_val") }}</th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card height="100%">
          <v-card-title>Resumen</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="header_resume"
              :items="resume"
              item-key="label"
              sort-by="label"
              mobile-breakpoint="0"
              class="elevation-0"
              loading-text="Cargando ..."
              dense
              hide-default-footer
            >
              <template v-slot:[`item.quantity`]="{ item }">
                {{ parseFloat(item.quantity).toLocaleString(2) }}
              </template>
              <template v-slot:[`item.value`]="{ item }">
                {{ "$ " + parseFloat(item.value).toLocaleString(2) }}
              </template>
              <template slot="body.append">
                <tr>
                  <th class="title">Total</th>
                  <th class="text-right">{{ "$ " + sumTable("resume", "value") }}</th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="loading_status" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-6">
          <p>Proceso</p>
          <p>{{ this.lStatus }}</p>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { webserver, getToday, formatCurrency } from "../services/webserver.js";

import createDoc from "../utils/create_doc.js";
export default {
  components: {},
  data() {
    return {
      loading_status: false,
      issueDate: getToday(),
      header_sales: [
        {
          text: "Categoría",
          align: "start",
          sortable: true,
          value: "category",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "end",
          sortable: true,
          value: "quantity",
          dataType: "number",
        },
        {
          text: "Descuento",
          align: "end",
          sortable: true,
          value: "discount",
          dataType: "number",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "price",
          dataType: "number",
        },
      ],
      header_inventory: [
        {
          text: "Categoría",
          align: "start",
          sortable: true,
          value: "categoria",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "end",
          sortable: true,
          value: "quantity",
          dataType: "number",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "price",
          dataType: "number",
        },
      ],
      header_events: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "concept",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "end",
          sortable: true,
          value: "quantity",
          dataType: "number",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "price",
          dataType: "number",
        },
      ],
      header_payments: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "type",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "end",
          sortable: true,
          value: "quantity",
          dataType: "number",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "value",
          dataType: "number",
        },
      ],
      header_resume: [
        {
          text: "Concepto",
          align: "start",
          sortable: true,
          value: "label",
          dataType: "text",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "value",
          dataType: "number",
        },
      ],
      cash_data: [],
      cash_type: [],
      dialog: false,
      item: createDoc(),
      lStatus: "",
      settings: null,
      sales: [],
      inventory: [],
      events: [],
      payments: [],
      cin: [],
      cout: [],
      totalSales: 0,
      totalDiscounts: 0,
      totalCambio: 0,
      totalGarantia: 0,
      resume: [
        { label: "Ventas totales", value: 0 },
        { label: "Descuentos", value: 0 },
        { label: "Cambios", value: 0 },
        { label: "Garantías", value: 0 },
      ],
      // chartData: [],
      // chartOptions: {
      //   curveType: "function",
      //   legend: { position: "right" },
      //   interpolateNulls: true,
      //   crosshair: { trigger: "both", opacity: 0.95, color: "#39FF14" },
      //   title: "",
      //   pieHole: 0.4,
      //   isStacked: false,
      //   hAxis: {
      //     title: "",
      //     slantedText: true,
      //     slantedTextAngle: 15,
      //   },
      //   height: 300,
      // },
      chartInventory: ["Categoría", "Cantidad"],
      chartSales: ["Categoría", "Cantidad"],
    };
  },
  mounted() {
    console.log(window.settings);
    this.get_report();
    this.settings = window.settings;
  },
  methods: {
    formatCurrency,
    formatNumber(value) {
      if (!value && value !== 0) return "0";
      return new Intl.NumberFormat("es-CO").format(value);
    },

    getTotalInventory() {
      return this.inventory.reduce(
        (sum, item) => sum + (parseFloat(item.quantity) || 0),
        0
      );
    },

    getTotalCashIn() {
      return this.cin.reduce((sum, item) => sum + (parseFloat(item.doc_val) || 0), 0);
    },

    getTotalCashOut() {
      return this.cout.reduce((sum, item) => sum + (parseFloat(item.doc_val) || 0), 0);
    },
    sumTable(table, key) {
      // sum data in give key (property)
      return parseFloat(
        this[table].reduce((a, b) => a + (parseFloat(b[key]) || 0), 0)
      ).toLocaleString(2);
    },
    async get_report() {
      this.loading_status = true;
      try {
        this.totalSales = 0;
        this.totalDiscounts = 0;
        this.totalCambio = 0;
        this.totalGarantia = 0;
        var reports = ["sales", "inventory", "payments", "events", "cashIN", "cashOUT"];

        var report = "";
        for (report of reports) {
          var qry = {};
          qry.store = window.store.store_id;
          qry.issueDate = this.issueDate;
          qry.report = report;
          console.log(qry);
          this.lStatus = "Consultando : " + qry.report;
          let promise = new Promise((resolve, reject) => {
            webserver(
              "cash_register_report_b",
              qry,
              function (data) {
                resolve(data);
              },
              function () {
                reject([]);
              }
            );
          });
          let data = await promise;
          console.log(data);
          var result = [];
          var dtSet = [];
          switch (report) {
            case "sales":
              data.forEach((item) => {
                console.log(this.settings["CATEGORIA"]);
                item.category = this.settings["CATEGORIA"].find(
                  (itm) => itm.codigo == item.categoria
                ).valor;
                item.quantity = parseFloat(item.quantity);
                this.totalSales += parseFloat(item.price);
                this.totalDiscounts += parseFloat(item.discount);
                this.resume[0].value = this.totalSales;
                this.resume[1].value = this.totalDiscounts;
              });
              this.sales = data;

              data.reduce(function (res, value) {
                if (!res[value.category]) {
                  res[value.category] = { label: value.category, value: 0 };
                  result.push(res[value.category]);
                }
                res[value.category].value += parseFloat(value.quantity);
                return res;
              }, {});

              result.sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0));

              dtSet.push(["Categoría", "Cantidad"]);
              result.forEach((rg) => {
                var item = [];
                item.push(rg.label);
                item.push(rg.value);
                dtSet.push(item);
              });

              this.chartSales = dtSet;

              break;

            case "inventory":
              data.forEach((item) => {
                // item.category = this.settings["CATEGORIA"].find(
                //   (itm) => itm.codigo == item.categoria
                // ).valor;
                item.quantity = parseFloat(item.quantity);
              });

              this.inventory = data;
              data.reduce(function (res, value) {
                if (!res[value.category]) {
                  res[value.category] = { label: value.category, value: 0 };
                  result.push(res[value.category]);
                }
                res[value.category].value += parseFloat(value.quantity);
                return res;
              }, {});

              result.sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0));

              dtSet.push(["Categoría", "Cantidad"]);
              result.forEach((rg) => {
                var item = [];
                item.push(rg.label);
                item.push(rg.value);
                dtSet.push(item);
              });

              this.chartInventory = dtSet;

              break;

            case "payments":
              console.log(data);
              data.forEach((item) => {
                if (item.type === "CAMBIO")
                  this.resume[2].value += parseFloat(item.value);
                if (item.type === "GARANTIA")
                  this.resume[3].value += parseFloat(item.value);
              });
              this.payments = data;
              break;
            case "events":
              console.log("cashIN", data);
              this.events = data;
              break;
            case "cashIN":
              console.log("cashIN", data);
              this.cin = data;
              break;
            case "cashOUT":
              console.log("cashOUT", data);
              this.cout = data;
              break;
          }
        }
        this.updateTotals();
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.loading_status = false;
      }
    },
    updateTotals() {
      // Actualizar resumen
      this.resume = [
        { label: "Ventas totales", value: this.totalSales },
        { label: "Descuentos", value: this.totalDiscounts },
        { label: "Cambios", value: this.totalCambio },
        { label: "Garantías", value: this.totalGarantia },
        { label: "Ingresos de Caja", value: this.getTotalCashIn() },
        { label: "Egresos de Caja", value: this.getTotalCashOut() },
      ];
    },
  },
};
</script>

<style></style>
